@use "@fukuri-admins/ui/layout" as *;

.DashboardContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;

  &__Main {
    width: calc(100% - 64px);
    background-color: $White;
    border-radius: 16px;
    padding: 40px 32px 56px;
    margin: 56px auto;
    @media screen and (max-width: $TB) {
      background-color: background('Secondary');
      width: 100%;
      padding: 0;
      border-radius: 0;
      margin-top: 80px;
    }

    // visiblePartnerHeaderがtrueの場合のmargin調整
    &__WithHeader {
      margin: calc(56px + 56px) auto 56px;
    }
  }

  &__Footer {
    text-align: center;
    padding: 24px;
    background-color: #f9faf9;

    @media screen and (max-width: $TB) {
      display: none;
    }
  }

  &__Links {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 16px;
    @media screen and (max-width: $TB) {
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }

    a {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: $TextInput;
      font-weight: 600;
      text-decoration: none !important;
      transition: opacity 0.2s ease-out;
      &:hover {
        opacity: 0.7;
      }
    }
  }

  &__Copyright {
    font-size: 12px;
    color: $Text;
  }
}
